<template>
  <div class="filters-container">
    <div class="filter d-flex flex-column">
      <h5>{{ t('legend') }}</h5>
      <div class="info collapse show">
        <div class="legend-row">
          <span class="legend-dot dot-ok"></span>
          <span>1 - {{ t('available') }}</span>
        </div>
        <div class="legend-row">
          <span class="legend-dot dot-bad"></span>
          <span>2 - {{ t('unavailable') }}</span>
        </div>
        <div class="legend-row">
          <span class="legend-dot dot-na"></span>
          <span>0 / NULL - {{ t('no-data') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FilterLocationStatusesData",
};
</script>

<style scoped>
.filters-container {
  width: 365px;
  background: url("../assets/l-filter-bg.png") repeat-y right;
}

.filter h5 {
  padding: 10px 20px;
  background-color: white;
  position: relative;
  background: white url("../assets/h-filter-bg.png") repeat-y right top;
}

.info {
  font-size: 13px;
  padding: 12px 20px;
  border-bottom: 1px solid #bbbbbb;
  background: #fff;
}

.legend-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.legend-row:last-child {
  margin-bottom: 0;
}

.legend-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: inline-block;
}

.dot-ok {
  background-color: #2e7d32;
}

.dot-bad {
  background-color: #c62828;
}

.dot-na {
  background-color: #9e9e9e;
}
</style>
